import { NextActionMap } from 'appRootPath/models/commercial-papers.model';

export const ACTOR_STATES = {
  INIT: 'init',
  // Issuer
  WAITING_FOR_INVESTOR_BID: 'waiting_for_investor_bid',
  WAITING_FOR_INVESTOR_AFTER_COUNTER: 'negotiate',
  WAITING_INVESTOR_REEVAL_CBC: 'waiting_for_investor_reevaluation',
  BID_REJECTED: 'rejected_bids',
  AUCTION_CLOSED: 'close_auction',
  // Investor
  WAITING_FOR_SELF_BID: 'place_bid',
  WAITING_FOR_ISSUER_AFTER_BID: 'waiting_for_issuer_after_bid',
  WAITING_FOR_ISSUER_AFTER_COUNTER: 'negotiate',
  WAITING_FOR_ISSUER_TO_CLOSE_AUCTION: 'waiting_for_auction_close',
  WAITING_FOR_SELF_REEVAL_CBC: 'reevaluate_accepted_bid'
};


export const BID_STATES = {
  ISSUER_AFTER_INVESTOR_SENT_BID: 'invB',
  ISSUER_AFTER_ISSUER_ACCEPTS_BID: 'invBIssA',
  INVESTOR_AFTER_ISSUER_COUNTERS_BID: 'invBIssC',
  ISSUER_AFTER_INVESTOR_COUNTER: 'invBIssCInvC',
  ISSUER_REJECT_AFTER_INVESTOR_COUNTER: 'tInvBIssCInvCIssR',
  INVESTOR_ACCEPTS_AFTER_ISSUER_COUNTER: 'tInvBIssCInvA',
  ISSUER_ACCEPTS_AFTER_INVESTOR_ACCEPT: 'invBIssCinvAIssA',
  INVESTOR_AFTER_BOTH_COUNTER: 'invBIssCInvCIssC',
  ISSUER_AFTER_BOTH_COUNTER_INV_ACCEPT: 'tInvBIssCinvCissCinvA',
  ISSUER_REJECTED_BID: 'invBIssR',
  ISSUER_ACCEPTS_AFTER_INVESTOR_COUNTER: 'invCIssA',
  INV_REJECTS_ISSUER_COUNTER: 'tInvBIssCInvR',
  INV_REJECTS_BOTH_COUNTER: 'invCissCinvR',
  ISSUER_ACCEPTS_INVESTOR_COUNTER_CBC: 'invBissCinvCissACBC',
  ISSUER_ACCEPTS_INVESTOR_REJECTS_CBC: 'invBissCinvCissAinvRCBC',
  ISSUER_REJECTS_AFTER_BOTH_COUNTER: 'tInvBIssCInvCIssCInvCIssR',
  INVESTOR_ON_ISSUER_ACCEPT_CBC: 'invBIssACBC',
  INVESTOR_ACCEPTS_ON_ISSUER_ACCEPT_CBC: 'tInvBIssAInvACBC',
  INVESTOR_REJECTS_ON_ISSUER_ACCEPT_CBC: 'tInvBIssAInvRCBC',
  ISSUER_REJECTS_INV_ACCEPT_CBC: 'tInvBCBCIssCInvAIssR',
  INV_COUNTERS_AFTER_BOTH_COUNTER_ISSUER_COUNTERS: 'tInvBIssCInvCIssCInvC',
  INV_ACCEPTS_AFTER_BOTH_COUNTER_ISSUER_ACCEPTS_CBC: 'tInvBIssCInvCIssAInvACBC',
  INVESTOR_REJECTS_ON_ISSUER_COUNTER_CBC: 'tInvBIssCInvCIssCInvR',
  BOTH_REJECT_CBC: 'tInvBIssCInvCInvRIssRCBC',
  ISSUER_REJECT_BOTH_COUNTER_ISS_COUNTER_INV_A: 'tInvBIssCInvCIssCInvAIssR',
  DEFAULT_STATE: 'default'
};

export const BID_ACTIONS = {
  REJECT_BID: 'reject_bid',
  ACCEPT_BID: 'accept_bid',
  COUNTER_BID: 'counter_bid',
  COUNTER_NEGOTIATION: 'counter_negotiation',
  REJECT_NEGOTIATION: 'reject_negotiation',
  ACCEPT_NEGOTIATION: 'accept_negotiation',
  ACCEPT_REEVAL_CBC: 'reevaluation_accepted',
  REJECT_REEVAL_CBC: 'reevaluation_rejected',
  PLACE_BID: 'bid_placed',
  INVESTOR_INIT: 'place_bid',
  ACCEPT_BID_WITH_CBC: 'accept_bid_with_cbc',
  AUCTION_CLOSED: 'auction_closed',
  BID_AGAIN: 'bid_again',
  ACCEPT_NEGOTIATION_WITH_CBC: 'accept_negotiation_with_cbc'
};

// First is issuer state then investor state
export const BID_STATES_FROM_ACTOR_STATES = {
  [ACTOR_STATES.WAITING_FOR_INVESTOR_BID]: {
    [ACTOR_STATES.WAITING_FOR_ISSUER_AFTER_BID]: BID_STATES.ISSUER_AFTER_INVESTOR_SENT_BID,
    [ACTOR_STATES.WAITING_FOR_ISSUER_AFTER_COUNTER]: BID_STATES.INVESTOR_AFTER_BOTH_COUNTER,
    [ACTOR_STATES.BID_REJECTED]: BID_STATES.INV_REJECTS_BOTH_COUNTER
  },
  [ACTOR_STATES.AUCTION_CLOSED]: {
    [ACTOR_STATES.WAITING_FOR_ISSUER_TO_CLOSE_AUCTION]: BID_STATES.ISSUER_AFTER_ISSUER_ACCEPTS_BID,
    [ACTOR_STATES.WAITING_FOR_ISSUER_AFTER_COUNTER]: BID_STATES.ISSUER_ACCEPTS_AFTER_INVESTOR_COUNTER
  },
  [ACTOR_STATES.WAITING_FOR_INVESTOR_AFTER_COUNTER]: {
    [ACTOR_STATES.WAITING_FOR_ISSUER_AFTER_BID]: BID_STATES.INVESTOR_AFTER_ISSUER_COUNTERS_BID,
    [ACTOR_STATES.WAITING_FOR_ISSUER_AFTER_COUNTER]: BID_STATES.ISSUER_AFTER_INVESTOR_COUNTER
  },
  [ACTOR_STATES.BID_REJECTED]: {
    [ACTOR_STATES.BID_REJECTED]: BID_STATES.ISSUER_REJECTED_BID
  },
  [ACTOR_STATES.WAITING_INVESTOR_REEVAL_CBC]: {
    [ACTOR_STATES.WAITING_FOR_ISSUER_AFTER_COUNTER]: BID_STATES.ISSUER_ACCEPTS_INVESTOR_COUNTER_CBC,
    [ACTOR_STATES.BID_REJECTED]: BID_STATES.ISSUER_ACCEPTS_INVESTOR_REJECTS_CBC,
    [ACTOR_STATES.WAITING_FOR_SELF_REEVAL_CBC]: BID_STATES.INVESTOR_ON_ISSUER_ACCEPT_CBC
  }
};

export const ISSUER_STATE_NEXT_ACTIONS = {
  [BID_STATES.ISSUER_AFTER_INVESTOR_SENT_BID]: [
    BID_ACTIONS.ACCEPT_BID,
    BID_ACTIONS.COUNTER_BID,
    BID_ACTIONS.REJECT_BID
  ],
  [BID_STATES.INVESTOR_ACCEPTS_AFTER_ISSUER_COUNTER]: [
    BID_ACTIONS.ACCEPT_NEGOTIATION,
    BID_ACTIONS.REJECT_NEGOTIATION
  ],
  [BID_STATES.ISSUER_AFTER_INVESTOR_COUNTER]: [
    BID_ACTIONS.ACCEPT_NEGOTIATION,
    BID_ACTIONS.COUNTER_NEGOTIATION,
    BID_ACTIONS.REJECT_NEGOTIATION
  ],
  [BID_STATES.ISSUER_AFTER_BOTH_COUNTER_INV_ACCEPT]: [
    BID_ACTIONS.ACCEPT_BID,
    BID_ACTIONS.COUNTER_BID,
    BID_ACTIONS.REJECT_BID
  ],
  [BID_STATES.INV_COUNTERS_AFTER_BOTH_COUNTER_ISSUER_COUNTERS]: [
    BID_ACTIONS.ACCEPT_BID,
    BID_ACTIONS.COUNTER_BID,
    BID_ACTIONS.REJECT_BID
  ]
};

export const ISSUER_CURRENT_STATE_CONFIG = {
  [BID_STATES.ISSUER_AFTER_INVESTOR_SENT_BID]: { shortName: 'WYA' },
  [BID_STATES.ISSUER_AFTER_ISSUER_ACCEPTS_BID]: { shortName: '' },
  [BID_STATES.INVESTOR_AFTER_ISSUER_COUNTERS_BID]: { shortName: 'WI' },
  [BID_STATES.INVESTOR_ACCEPTS_AFTER_ISSUER_COUNTER]: { shortName: 'WYA-IA' },
  [BID_STATES.ISSUER_AFTER_INVESTOR_COUNTER]: { shortName: 'WYA' },
  [BID_STATES.INVESTOR_AFTER_BOTH_COUNTER]: { shortName: 'WI' },
  [BID_STATES.ISSUER_AFTER_BOTH_COUNTER_INV_ACCEPT]: { shortName: 'WYA-IA' },
  [BID_STATES.INV_REJECTS_BOTH_COUNTER]: { shortName: 'Investor Rejected' },
  [BID_STATES.INV_REJECTS_ISSUER_COUNTER]: { shortName: 'Investor Rejected' },
  [BID_STATES.ISSUER_ACCEPTS_INVESTOR_REJECTS_CBC]: { shortName: 'Investor Rejected CBC' },
  [BID_STATES.INVESTOR_REJECTS_ON_ISSUER_ACCEPT_CBC]: { shortName: 'Investor Rejected CBC' },
  [BID_STATES.ISSUER_REJECTED_BID]: { shortName: 'You Rejected' },
  [BID_STATES.ISSUER_REJECT_AFTER_INVESTOR_COUNTER]: { shortName: 'You Rejected' },
  [BID_STATES.ISSUER_REJECTS_AFTER_BOTH_COUNTER]: { shortName: 'You Rejected' },
  [BID_STATES.INVESTOR_ON_ISSUER_ACCEPT_CBC]: { shortName: 'WI-CBC' },
  [BID_STATES.ISSUER_REJECTS_INV_ACCEPT_CBC]: { shortName: 'You Rejected' },
  [BID_STATES.INVESTOR_REJECTS_ON_ISSUER_COUNTER_CBC]: { shortName: 'Investor Rejected CBC' },
  [BID_STATES.INV_COUNTERS_AFTER_BOTH_COUNTER_ISSUER_COUNTERS]: { shortName: 'WYA' },
  [BID_STATES.BOTH_REJECT_CBC]: { shortName: 'Investor Rejected' },
  [BID_STATES.ISSUER_REJECT_BOTH_COUNTER_ISS_COUNTER_INV_A]: { shortName: 'You Rejected' }
};

export const INVESTOR_STATE_NEXT_ACTIONS = {
  [BID_STATES.INVESTOR_AFTER_ISSUER_COUNTERS_BID]: [
    BID_ACTIONS.ACCEPT_BID,
    BID_ACTIONS.COUNTER_BID,
    BID_ACTIONS.REJECT_BID,
  ],
  [BID_STATES.INVESTOR_AFTER_BOTH_COUNTER]: [
    BID_ACTIONS.ACCEPT_NEGOTIATION,
    BID_ACTIONS.COUNTER_NEGOTIATION,
    BID_ACTIONS.REJECT_NEGOTIATION,
  ],
  [BID_STATES.ISSUER_ACCEPTS_INVESTOR_COUNTER_CBC]: [
    BID_ACTIONS.ACCEPT_NEGOTIATION,
    BID_ACTIONS.REJECT_NEGOTIATION
  ],
  [BID_STATES.INVESTOR_ON_ISSUER_ACCEPT_CBC]: [
    BID_ACTIONS.ACCEPT_REEVAL_CBC,
    BID_ACTIONS.REJECT_REEVAL_CBC
  ],
  // Bid Again
  [BID_STATES.ISSUER_REJECTED_BID]: [],
  [BID_STATES.ISSUER_REJECT_AFTER_INVESTOR_COUNTER]: [],
  [BID_STATES.INVESTOR_REJECTS_ON_ISSUER_ACCEPT_CBC]: [],
  [BID_STATES.INVESTOR_REJECTS_ON_ISSUER_COUNTER_CBC]: [],
  // No Next States Possible
  [BID_STATES.INV_REJECTS_ISSUER_COUNTER]: []

};

export const INVESTOR_CURRENT_STATE_CONFIG = {
  [BID_STATES.ISSUER_AFTER_INVESTOR_SENT_BID]: {
    state_name: 'WI',
    state_desc: 'Waiting for Issuer'
  },
  [BID_STATES.ISSUER_AFTER_ISSUER_ACCEPTS_BID]: {
    state_name: 'WI',
    state_desc: 'Issuer accepted quote. Waiting For RFQ close.'
  },
  [BID_STATES.INVESTOR_AFTER_ISSUER_COUNTERS_BID]: {
    state_name: 'WYA',
    state_desc: 'Waiting for Your Action'
  },
  [BID_STATES.INVESTOR_ACCEPTS_AFTER_ISSUER_COUNTER]: {
    state_name: 'WI',
    state_desc: 'You accepted Offer.  Waiting For issuer.'
  },
  [BID_STATES.ISSUER_ACCEPTS_AFTER_INVESTOR_ACCEPT]: {
    state_name: 'WI',
    state_desc: 'Issuer accepted Quote. Waiting For RFQ close.'
  },
  [BID_STATES.ISSUER_AFTER_INVESTOR_COUNTER]: {
    state_name: 'WI',
    state_desc: 'You countered. Waiting for issuer.'
  },
  [BID_STATES.ISSUER_AFTER_BOTH_COUNTER_INV_ACCEPT]: {
    state_name: 'WI',
    state_desc: 'You accepted. Waiting for issuer.'
  },
  [BID_STATES.INVESTOR_AFTER_BOTH_COUNTER]: {
    state_name: 'WYA',
    state_desc: 'Waiting for Your Action'
  },
  [BID_STATES.ISSUER_REJECTED_BID]: {
    state_name: 'REJ',
    state_desc: 'Quote Rejected'
  },
  [BID_STATES.ISSUER_ACCEPTS_AFTER_INVESTOR_COUNTER]: {
    state_name: 'WI',
    state_desc: 'Issuer accepted. Waiting For RFQ close.'
  },
  [BID_STATES.INVESTOR_ACCEPTS_ON_ISSUER_ACCEPT_CBC]: {
    state_name: 'WI',
    state_desc: 'You accepted. Waiting For RFQ close.'
  },
  [BID_STATES.INV_REJECTS_ISSUER_COUNTER]: {
    state_name: 'REJ',
    state_desc: 'You Rejected the Offer'
  },
  [BID_STATES.BOTH_REJECT_CBC]: {
    state_name: 'REJ',
    state_desc: 'You Rejected the Offer'
  },
  [BID_STATES.INV_REJECTS_BOTH_COUNTER]: {
    state_name: 'REJ',
    state_desc: 'You Rejected the Offer'
  },
  [BID_STATES.INVESTOR_REJECTS_ON_ISSUER_ACCEPT_CBC]: {
    state_name: 'REJ',
    state_desc: 'You Rejected quote confirmation (CBC)'
  },
  [BID_STATES.ISSUER_ACCEPTS_INVESTOR_COUNTER_CBC]: {
    state_name: 'WYA',
    state_desc: 'Issuer accepted. Waiting for your Confirmation.'
  },
  [BID_STATES.ISSUER_ACCEPTS_INVESTOR_REJECTS_CBC]: {
    state_name: 'REJ',
    state_desc: 'You Rejected the Offer'
  },
  [BID_STATES.ISSUER_REJECT_AFTER_INVESTOR_COUNTER]: {
    state_name: 'REJ',
    state_desc: 'Quote Rejected'
  },
  [BID_STATES.ISSUER_REJECTS_AFTER_BOTH_COUNTER]: {
    state_name: 'REJ',
    state_desc: 'Quote Rejected'
  },
  [BID_STATES.INVESTOR_ON_ISSUER_ACCEPT_CBC]: {
    state_name: 'WYA',
    state_desc: 'Issuer accepted. Waiting for your Confirmation.'
  },
  [BID_STATES.ISSUER_REJECTS_INV_ACCEPT_CBC]: {
    state_name: 'REJ',
    state_desc: 'Quote Rejected'
  },
  [BID_STATES.INV_COUNTERS_AFTER_BOTH_COUNTER_ISSUER_COUNTERS]: {
    state_name: 'WI',
    state_desc: 'You countered. Waiting for issuer.'
  },
  [BID_STATES.INV_ACCEPTS_AFTER_BOTH_COUNTER_ISSUER_ACCEPTS_CBC]: {
    state_name: 'WRC',
    state_desc: 'You Accepted. Waiting for RFQ Close.'
  },
  [BID_STATES.INVESTOR_REJECTS_ON_ISSUER_COUNTER_CBC]: {
    state_name: 'REJ',
    state_desc: 'You rejected Quote on confirmation.'
  },
  [BID_STATES.ISSUER_REJECT_BOTH_COUNTER_ISS_COUNTER_INV_A]: {
    state_name: 'REJ',
    state_desc: 'Quote Rejected'
  }
};

export const ISSUER_NEXT_ACTIONS_CONFIG = {
  [BID_ACTIONS.COUNTER_BID]: {
    btnText: 'Counter',
    btnColorMod: 'warning',
    asideTitle: 'Counter Quote',
    asideBtn: 'Counter',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: 'Your Counter Offer',
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_BID]: {
    btnText: 'Accept',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote',
    asideBtn: 'Accept',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.REJECT_BID]: {
    btnText: 'Reject',
    btnColorMod: 'normal',
    asideTitle: 'Reject Quote',
    asideBtn: 'Reject',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_NEGOTIATION]: {
    btnText: 'Accept',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote',
    asideBtn: 'Accept',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.REJECT_NEGOTIATION]: {
    btnText: 'Reject',
    btnColorMod: 'normal',
    asideTitle: 'Reject Quote',
    asideBtn: 'Reject',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.COUNTER_NEGOTIATION]: {
    btnText: 'Counter',
    btnColorMod: 'warning',
    asideTitle: 'Counter Quote',
    asideBtn: 'Counter',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: 'Your Counter Offer',
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_REEVAL_CBC]: {
    btnText: 'Accept',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote',
    asideBtn: 'Accept',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.REJECT_REEVAL_CBC]: {
    btnText: 'Reject',
    btnColorMod: 'normal',
    asideTitle: 'Reject Quote',
    asideBtn: 'Reject',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  }
};

export const INVESTOR_NEXT_ACTIONS_CONFIG: NextActionMap = {
  [BID_ACTIONS.INVESTOR_INIT]: {
    btnText: 'Send A Quote',
    btnColorMod: 'success',
    asideTitle: 'Send a Quote',
    asideBtn: 'Reject',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: 'Your Quote',
    asideShowOtherBid: false
  },
  [BID_ACTIONS.PLACE_BID]: {
    btnText: 'Send A Quote',
    btnColorMod: 'success',
    asideTitle: 'Send a Quote',
    asideBtn: 'Reject',
    asideOtherHeader: null,
    asideFormHeader: 'Your Quote',
    asideShowOtherBid: false
  },
  [BID_ACTIONS.ACCEPT_BID]: {
    btnText: 'Accept',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote',
    asideBtn: 'Accept',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.COUNTER_BID]: {
    btnText: 'Counter',
    btnColorMod: 'warning',
    asideTitle: 'Counter Quote',
    asideBtn: 'Counter',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: 'Your Counter Quote',
    asideShowOtherBid: true
  },
  [BID_ACTIONS.REJECT_BID]: {
    btnText: 'Reject',
    btnColorMod: 'normal',
    asideTitle: 'Reject Quote',
    asideBtn: 'Reject',
    asideOtherHeader: 'Investor\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_BID_WITH_CBC]: {
    btnText: 'Accept (CBC)',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote (CBC)',
    asideBtn: 'Accept',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_NEGOTIATION_WITH_CBC]: {
    btnText: 'Accept N (CBC)',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote (CBC)',
    asideBtn: 'Accept',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_REEVAL_CBC]: {
    btnText: 'Accept (CBC)',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote (CBC)',
    asideBtn: 'Accept',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.REJECT_REEVAL_CBC]: {
    btnText: 'Reject (CBC)',
    btnColorMod: 'normal',
    asideTitle: 'Reject Quote (CBC)',
    asideBtn: 'Reject',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.COUNTER_NEGOTIATION]: {
    btnText: 'Counter',
    btnColorMod: 'warning',
    asideTitle: 'Counter Quote',
    asideBtn: 'Counter',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: 'Your Counter Quote',
    asideShowOtherBid: true
  },
  [BID_ACTIONS.ACCEPT_NEGOTIATION]: {
    btnText: 'Accept',
    btnColorMod: 'success',
    asideTitle: 'Accept Quote',
    asideBtn: 'Accept',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.REJECT_NEGOTIATION]: {
    btnText: 'Reject',
    btnColorMod: 'normal',
    asideTitle: 'Reject Quote',
    asideBtn: 'Reject',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  },
  [BID_ACTIONS.AUCTION_CLOSED]: {
    btnText: 'Close RFQ',
    btnColorMod: 'normal',
    asideTitle: 'Close RFQ',
    asideBtn: 'Close RFQ',
    asideOtherHeader: 'Issuer\'s Quote',
    asideFormHeader: null,
    asideShowOtherBid: true
  }
};
